export const GET_VENDOR_ITEMS = 'GET_VENDOR_ITEMS';
export const SET_VENDOR_ITEMS = 'SET_VENDOR_ITEMS';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_VENDOR_ITEM = 'SET_VENDOR_ITEM';
export const ADD_VENDOR_ITEM = 'ADD_VENDOR_ITEM';
export const EMPTY_VENDOR_ITEM = 'EMPTY_VENDOR_ITEM';
export const DELETE_VENDOR_ITEM = 'DELETE_VENDOR_ITEM';
export const EDIT_VENDOR_ITEM = 'EDIT_VENDOR_ITEM';
export const UPDATE_VENDOR_ITEM = 'UPDATE_VENDOR_ITEM';
export const SET_VENDOR_ITEM_FILTER = 'SET_VENDOR_ITEM_FILTER';